import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import adminUserSectionStaticContentSlice from "../sitecoreStaticContent/adminUserSectionStaticContentSlice";
import commonStaticContentSlice from "../sitecoreStaticContent/commonStaticContentSlice";
import appStateSlice from "./appState/appStateSlice";
import authenticatedUserSlice, {
  persistAuthConfig,
} from "./auth/authenticatedUserSlice";
import createClientSlice, {
  persistCreateClientConfig,
} from "./client/createClientSlice";
import layoutSlice, { persistAppConfig } from "./client/layoutSlice";
import programSlice, { persistProgramConfig } from "./program/programSlice";
import mdmActivitySlice, {
  persistMdmActivityConfig,
} from "./mdmActivity/mdmActivitySlice";
import manageUserSlice, {
  persistManageUserConfig,
} from "./manageUser/manageUserSlice";
import manageBulkProcessSlice, {
  persistManageBulkProcessConfig,
} from "./manageBulkProcess/manageBulkProcessSlice";
import formValiditySlice, {
  persistFormValidityConfig,
} from "./formValiditySlice/formValiditySlice";
import projectSlice, { persistProjectConfig } from "./project/projectSlice";

const persistRootConfig = {
  version: 1,
  key: "mpg_next_admin_root_v1",
  storage,
  whitelist: [],
};

const persistStaticContentConfig = {
  version: 1,
  key: "mpg_next_admin_static_content_v1",
  storage,
  whitelist: [],
};

export const staticContentReducer = combineReducers({
  commonStaticContentSlice,
  adminUserSectionStaticContentSlice,
});

export const authReducer = combineReducers({
  authenticatedUserSlice,
});

export const createClientReducer = combineReducers({
  client: createClientSlice,
});

export const programReducer = combineReducers({
  program: programSlice,
});

export const mdmActivityReducer = combineReducers({
  mdmActivity: mdmActivitySlice,
});

export const manageBulkProcessReducer = combineReducers({
  manageBulkProcess: manageBulkProcessSlice,
});

export const formValidityReducer = combineReducers({
  formValidity: formValiditySlice,
});

export const manageUserReducer = combineReducers({
  manageUser: manageUserSlice,
});
export const projectReducer = combineReducers({
  project: projectSlice,
});

// export const projectReducer = combineReducers({
//   project: projectSlice,
// });

export const appReducer = combineReducers({
  layoutSlice,
  appState: appStateSlice,
});

export const PERSIST_REDUCERS = {
  auth: persistReducer(persistAuthConfig, authReducer),
  createClient: persistReducer(persistCreateClientConfig, createClientReducer),
  program: persistReducer(persistProgramConfig, programReducer),
  mdmActivity: persistReducer(persistMdmActivityConfig, mdmActivityReducer),
  manageBulkProcess: persistReducer(
    persistManageBulkProcessConfig,
    manageBulkProcessReducer,
  ),
  formValidity: persistReducer(persistFormValidityConfig, formValidityReducer),
  manageUser: persistReducer(persistManageUserConfig, manageUserReducer),
  app: persistReducer(persistAppConfig, appReducer),
  staticContent: persistReducer(
    persistStaticContentConfig,
    staticContentReducer,
  ),
  project: persistReducer(persistProjectConfig, projectReducer),
};

export const rootReducer = combineReducers({
  ...PERSIST_REDUCERS,
});

export type IRootState = ReturnType<typeof rootReducer>;
export default persistReducer(persistRootConfig, rootReducer);
